document.addEventListener('DOMContentLoaded', () => {
  const cardsContainer = document.querySelector('.formed__cards');
  const copyContainer = document.querySelector('.formed__copy');

  if (!cardsContainer || !copyContainer) return;

  const items = copyContainer.querySelectorAll('.card-land');
  const firstTwo = Array.from(items).slice(0, 2);

  firstTwo.forEach(el => {
    const clone = el.cloneNode(true);
    cardsContainer.appendChild(clone);
  });
});
